import Button from '@components/atoms/button';
import { BodyRegular, H3 } from '@components/atoms/typography';
import { PAYPAL_AUTOPAY_URL } from '@lib/constants';

export const PayPalInfo = () => (
  <div className="shadow-md rounded-lg p-4 my-5">
    <div>
      <H3>Managing your PayPal subscription</H3>
      <div className="mt-2">
        <BodyRegular>
          Your renewal date, price and payment details are held by PayPal. Sign
          in to PayPal and open your automatic payments to view or change them.
        </BodyRegular>
      </div>
    </div>
    <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
      <Button
        href={PAYPAL_AUTOPAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="tertiary"
      >
        Manage on PayPal
      </Button>
    </div>
  </div>
);
